<template>
  <div class="activity-records-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.EidAlFitr.k016')" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="bg-block">
      <div v-for="(item, index) in records" :key="index">
        <div class="record-time">{{ handleMoment(item.time, 'YYYY-MM-DD HH:mm:ss') }}</div>
        <div class="record-item">
          <div v-for="(rewardItem, rewardIndex) in item.rewards" :key="rewardIndex">
            <div class="img-wrap">
              <img v-if="rewardItem.propType !== 10" :src="resolveMatchImg(rewardItem.propType)" alt="" />
              <img v-else class="avatar-bar" src="./images/avatar-bar.png" />
            </div>
            <div class="rewards-count">x{{ rewardItem.count }}</div>
          </div>
        </div>
      </div>

      <div class="list-status">
        <div v-if="!records.length" style="height: 40vh"></div>
        <van-loading v-if="isLoading" color="#ffffff" size="25px" />
        <div v-else-if="!records.length || (finished && records.length)" class="status-empty">{{ $t('lang.ActCommon.k099') }}</div>
      </div>

      <div :style="`height: ${bottomBarHeight}px`"></div>
    </div>
  </div>
</template>

<script>
import { normalActHistory } from './apidir/api.js'

export default {
  data() {
    return {
      page: 1,
      limit: 5,
      isLoading: false,
      finished: false,
      records: []
    }
  },
  methods: {
    resolveMatchImg(propType) {
      if (this.propsMap[propType]) {
        return this.getMatchImg(this.propsMap[propType])
      }
      return ''
    },
    fetchList() {
      if (this.isLoading || this.finished) {
        return
      }

      this.isLoading = true

      normalActHistory({
        offset: (this.page - 1) * this.limit,
        limit: this.limit
      })
        .then((resData) => {
          if (resData && !resData.error) {
            if (Array.isArray(resData)) {
              this.records = this.records.concat(resData)

              // 仅根据当前页返回数量判断是否还有更多
              if (resData.length < this.limit) {
                this.finished = true
              }
              if (!resData.length && this.page > 1) {
                this.finished = true
              }
            }
          }
        })
        .catch(() => {
          // 请求失败时回退页码，避免死页
          if (this.page > 1) {
            this.page -= 1
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleScrollLoadMore() {
      if (this.isLoading || this.finished) {
        return
      }
      this.page += 1
      this.fetchList()
    },
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const clientHeight = document.documentElement.clientHeight || window.innerHeight || 0
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0
      const threshold = 20

      if (scrollTop + clientHeight >= scrollHeight - threshold) {
        this.handleScrollLoadMore()
      }
    }
  },
  created() {
    document.body.scrollTo({ top: 0 })
    this.fetchList()
  },
  mounted() {
    document.body.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.activity-records-root {
  width: 100%;
  min-height: calc(100vh - 150px);
  background: #135e38;

  .custom-nav-block {
    background: #135e38;
  }

  .bg-block {
    position: relative;
    min-height: 100vh;

    padding: 16px 10px 20px;

    .list-status {
      padding: 8px 0 0;
      font-family: 'Inter-Regular';
      font-size: 12px;
      line-height: 18px;
      color: rgba(255, 255, 255, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .record-time {
      color: rgba(255, 255, 255, 0.7);
      font-family: 'Inter-Regular';
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      padding: 0 5px;
    }

    .record-item {
      display: block;
      margin: auto;
      padding: 12px 0 0;
      border-radius: 8px;
      font-size: 0;

      & > div {
        width: 20%;
        display: inline-block;
        text-align: center;
        padding-bottom: 24px;
        .img-wrap {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 44px;
          border-radius: 8px;
          background: #f9fff5;
          img {
            width: 28px;
          }
        }
        .rewards-count {
          font-family: 'TikTokSans-Regular';
          font-weight: bold;
          font-size: 12px;
          color: #ffffff;
          line-height: 22px;
          margin-top: 4px;
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'Inter-Regular';
  font-weight: 600;
  color: #ffffff;
}
::v-deep .van-nav-bar__right .tit-right {
  line-height: 16px !important;
}
</style>
